// extracted by mini-css-extract-plugin
export default {"linkButtons":"Header_linkButtons__RuwoE","logo":"Header_logo__KvWnU","taglineImage":"Header_taglineImage__Zl389"};